import React from 'react'
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {ArrowLeftOutlined} from '@ant-design/icons'
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import MoreVertIcon from '@mui/icons-material/MoreVert';

const InnnerHeader = (props) => {
  return (
    <section className='header-car-booking-checkout'>
    <div className="bottom-nav ">
    <Container>
     <Row>
       <Col >
        <div className="checkout-heading-wrap d-flex justify-content-between ">
        <div className="left-head-wrap d-flex">
        <span><ArrowLeftOutlined /></span>
            <div className='car-title'>{props.title}</div>
        </div>

        <div className="right-head-wrap d-flex">
        <span><LocalPhoneIcon /></span>
            <div className='car-title'><MoreVertIcon /></div>
        </div>
            
            
        </div>
       </Col>
     </Row>
    </Container>
     </div>
     </section>
  )
}

export default InnnerHeader